const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/EmptyState/styles.ts';
import { css } from '@emotion/css';

export const rootStyle = css`
    label: EmptyState;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
`;
